var map = {
	"./Mail.png": 5894,
	"./Pipeline-heading-color.png": 1506,
	"./Pipeline-heading.png": 1712,
	"./audio.png": 8221,
	"./company_ico.png": 1652,
	"./contact_ico.png": 6061,
	"./excel.png": 8842,
	"./giphy.gif": 1837,
	"./iGlobe.png": 747,
	"./image.png": 6036,
	"./locate.png": 1749,
	"./meeting_webpart_heading-col.png": 5242,
	"./meeting_webpart_heading.png": 7943,
	"./o2s.png": 1213,
	"./onenote.png": 4475,
	"./pdf.png": 4729,
	"./ph.png": 7923,
	"./pin1.png": 8117,
	"./pin2.png": 1390,
	"./pin3.png": 3527,
	"./powerpoint.png": 4764,
	"./ssoProbability.png": 9665,
	"./txt.png": 2715,
	"./unknown.png": 757,
	"./video.png": 2506,
	"./word.png": 1203,
	"./xml.png": 1672,
	"./zip.png": 9126
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6467;